import { render, staticRenderFns } from "./LiveTable.vue?vue&type=template&id=71beb858&scoped=true&"
import script from "./LiveTable.vue?vue&type=script&lang=js&"
export * from "./LiveTable.vue?vue&type=script&lang=js&"
import style0 from "./LiveTable.vue?vue&type=style&index=0&id=71beb858&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71beb858",
  null
  
)

export default component.exports